/* ── helpers ── */
function G(id){ const el=document.getElementById(id); if(el)el.scrollIntoView({behavior:'smooth'}); }
function openM(id){ document.getElementById('m-'+id).classList.add('show'); document.body.style.overflow='hidden'; }
function closeM(id){ document.getElementById('m-'+id).classList.remove('show'); document.body.style.overflow=''; }
document.querySelectorAll('.mbg').forEach(m=>m.addEventListener('click',e=>{ if(e.target===m){ m.classList.remove('show'); document.body.style.overflow=''; }}));

/* ── account toggle ── */
let accLogin=true;
function toggleAcc(){
  accLogin=!accLogin;
  document.getElementById('m-acc-h').textContent=accLogin?'Welcome back':'Create your account';
  document.getElementById('m-acc-s').textContent=accLogin?'Sign in to access order history, custom order status, and subscription details.':'Join Aesthetic Appeal for early access to new drops, order tracking, and subscription management.';
  document.getElementById('m-acc-sw').innerHTML=accLogin?'New here? <a onclick="toggleAcc()">Create an account</a>':'Have an account? <a onclick="toggleAcc()">Sign in</a>';
}

/* ── toast ── */
function showT(msg){ const t=document.getElementById('toast'); document.getElementById('toast-msg').textContent=msg; t.classList.add('pop'); setTimeout(()=>t.classList.remove('pop'),3600); }

/* ── product filter ── */
function filt(btn,cat){ document.querySelectorAll('.fpill').forEach(b=>b.classList.remove('on')); btn.classList.add('on'); document.querySelectorAll('.pcard').forEach(c=>{ c.style.display=(cat==='all'||c.dataset.cat===cat)?'flex':'none'; }); }

/* ── runway year tabs ── */
function swRunway(btn,year){
  document.querySelectorAll('.ry-tab').forEach(b=>b.classList.remove('on'));
  document.querySelectorAll('.runway-content').forEach(c=>c.classList.remove('on'));
  btn.classList.add('on');
  document.getElementById('rc-'+year).classList.add('on');
}

/* ── color swatch pick ── */
function pickColor(el){ document.querySelectorAll('.cswatch').forEach(s=>s.classList.remove('on')); el.classList.add('on'); }

/* ── crystal multi-select dropdown ── */
function toggleCrystalDropdown(){
  const list=document.getElementById('crys-list');
  const disp=document.getElementById('crys-display');
  list.classList.toggle('open');
  disp.classList.toggle('open');
}
document.addEventListener('click',function(e){
  const wrap=document.querySelector('.crystal-dropdown');
  if(wrap && !wrap.contains(e.target)){
    const list=document.getElementById('crys-list');
    const disp=document.getElementById('crys-display');
    if(list) list.classList.remove('open');
    if(disp) disp.classList.remove('open');
  }
});
function syncCrystals(){
  const checks=document.querySelectorAll('.crystal-list input[type="checkbox"]:checked');
  const tags=document.getElementById('crys-tags');
  const disp=document.getElementById('crys-display-text');
  if(!tags||!disp) return;
  tags.innerHTML='';
  if(checks.length===0){ disp.textContent='Click to select crystals...'; return; }
  disp.textContent=checks.length+' crystal'+(checks.length>1?'s':'')+' selected';
  checks.forEach(c=>{
    const tag=document.createElement('div');
    tag.className='ctag';
    tag.innerHTML=c.value+' <span class="ctag-rm" onclick="removeTag(\''+c.value+'\')">×</span>';
    tags.appendChild(tag);
  });
}
function removeTag(val){
  const cb=document.querySelector('.crystal-list input[value="'+val+'"]');
  if(cb){ cb.checked=false; syncCrystals(); }
}

/* ── accessibility ── */
const aCSS=document.createElement('style');
aCSS.textContent=`body.lg-text{font-size:118%}body.hi-contrast{filter:contrast(1.3) brightness(1.08)}body.no-motion *{animation:none!important;transition:none!important}body.show-focus *:focus{outline:2px solid var(--gold)!important;outline-offset:3px!important}`;
document.head.appendChild(aCSS);

/* ── scroll fade-in ── */
const obs=new IntersectionObserver(entries=>{
  entries.forEach(e=>{ if(e.isIntersecting){ e.target.style.opacity='1'; e.target.style.transform='translateY(0)'; }});
},{ threshold:0.07 });
document.querySelectorAll('.pcard,.ap-card,.crys-card,.ch-card,.metal-card,.wis-card,.ev-card,.scard,.gal-item,.tutt-card,.st-card,.cmethod').forEach(el=>{
  el.style.opacity='0'; el.style.transform='translateY(20px)';
  el.style.transition='opacity 0.75s ease, transform 0.75s ease';
  obs.observe(el);
});
